<mat-card class="summary-card ytd">
	<div class="summary-title ytd">YTD WEEKLY AVERAGE (Up till last week)</div>
	<div class="summary-content">
		<!-- Repeat for each metric -->
		<div class="summary-metric">
			<span class="metric-label">TOTAL SALES</span>
			<span class="metric-value">{{ ytdWeeklySales | currency:'USD':'symbol':'1.0-0' }}</span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">TOTAL ORDERS / ITEMS</span>
			<span class="metric-value">{{ ytdWeeklyOrdersItems }}</span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">SALES VALUE / ITEM</span>
			<span class="metric-value">{{ ytdWeeklySalesValuePerItem | currency:'USD':'symbol':'1.2-2' }}</span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">AVERAGE ORDER $</span>
			<span class="metric-value">{{ ytdWeeklyAverageOrder | currency:'USD':'symbol':'1.2-2' }}</span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">SUSHI SALES</span>
			<span class="metric-value">{{ ytdWeeklySushiSales | currency:'USD':'symbol':'1.2-2' }}</span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">SUSHI ITEM SOLD</span>
			<span class="metric-value">{{ ytdWeeklySushiItemsSold | number:'0.0-0' }}</span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">BENTO SALES</span>
			<span class="metric-value">{{ ytdWeeklyBentoSales | currency:'USD':'symbol':'1.2-2' }}</span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">BENTO ITEM SOLD</span>
			<span class="metric-value">{{ ytdWeeklyBentoItemsSold | number:'0.0-0' }}</span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">COMMON SALES</span>
			<span class="metric-value">{{ ytdWeeklyCommonSales | currency:'USD':'symbol':'1.2-2'}}</span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">COMMON ITEM SOLD</span>
			<span class="metric-value">{{ ytdWeeklyCommonItemsSold | number:'0.0-0'}}</span>
		</div>
	</div>
</mat-card>